import { registerComponent, getComponentConfig } from "helpers";

registerComponent(
  "wyatt-accordion",
  class WyattAccordion extends HTMLElement {
    DEFAULT_CONFIG = {
      triggerSelector: ".accordion__trigger",
      panelSelector: ".accordion__panel",
      closeOthers: false,
      activePanels: [],
    };

    constructor() {
      super();

      this.config = getComponentConfig(this);
      this.triggers = Array.from(
        this.querySelectorAll(this.config.triggerSelector)
      );
      this.panels = Array.from(
        this.querySelectorAll(this.config.panelSelector)
      );

      this.addAccessibilityAttributes();

      this.config.activePanels.forEach((index) => this.activatePanel(index));

      this.triggers.forEach((trigger) => {
        trigger.addEventListener("click", this.handleClick.bind(this));
        trigger.addEventListener("keydown", this.handleKeydown.bind(this));
      });
    }

    handleClick(event) {
      event.preventDefault();

      const index = this.triggers.indexOf(event.currentTarget);

      if (event.currentTarget.getAttribute("active") === "true") {
        this.deactivatePanel(index);
      } else {
        if (this.config.closeOthers) {
          this.deactivateAllPanels();
        }
        this.activatePanel(index);
      }
    }

    handleKeydown(event) {
      let flag = false;

      switch (event.key) {
        case "ArrowUp":
          this.setFocusPrevious(event.currentTarget);
          flag = true;
          break;

        case "ArrowDown":
          this.setFocusNext(event.currentTarget);
          flag = true;
          break;

        case "Home":
          this.setFocusTo(0);
          flag = true;
          break;

        case "End":
          this.setFocusTo(this.triggers.length - 1);
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    setFocusPrevious(trigger) {
      const index = this.triggers.indexOf(trigger);

      if (index === 0) {
        this.setFocusTo(this.triggers.length - 1);
      } else {
        this.setFocusTo(index - 1);
      }
    }

    setFocusNext(trigger) {
      const index = this.triggers.indexOf(trigger);

      if (index === this.triggers.length - 1) {
        this.setFocusTo(0);
      } else {
        this.setFocusTo(index + 1);
      }
    }

    setFocusTo(index) {
      this.triggers[index].focus();
    }

    activatePanel(index) {
      this.triggers[index].setAttribute("aria-expanded", true);
      this.triggers[index].setAttribute("active", true);
      this.panels[index].setAttribute("active", true);
    }

    deactivatePanel(index) {
      this.triggers[index].setAttribute("aria-expanded", false);
      this.triggers[index].setAttribute("active", false);
      this.panels[index].setAttribute("active", false);
    }

    deactivateAllPanels() {
      this.triggers.forEach((trigger, index) => this.deactivatePanel(index));
    }

    addAccessibilityAttributes() {
      this.triggers.forEach((trigger, index) => {
        trigger.id = `accordion-${this.config.id}-trigger-${index}`;
        trigger.setAttribute("aria-expanded", false);
        trigger.setAttribute("active", false);
        trigger.setAttribute(
          "aria-controls",
          `accordion-${this.config.id}-panel-${index}`
        );
      });

      this.panels.forEach((panel, index) => {
        panel.id = `accordion-${this.config.id}-panel-${index}`;
        panel.setAttribute("role", "region");
        panel.setAttribute("active", false);
        panel.setAttribute(
          "aria-labelledby",
          `accordion-${this.config.id}-trigger-${index}`
        );
      });
    }
  }
);
